const Mock = require('mockjs');
const List = [{
    id: 0,
    siteName: "茶话网",
    path: "https://www.teaclub.top",
    desc: "一个简单的记录网站"
}]
const count = 15

for (let i = 0; i < count; i++) {
    List.push(Mock.mock({
        id: '@increment',
        siteName: "@cname",
        path: "@url",
        desc: "@ctitle(5,20)"
    }))
}

export default [
    {
        url: '/api/friend',
        type: 'get',
        response: config => {
            return {
                code: 20000,
                data: List
            }
        }
    }
]